import * as Yup from 'yup';
import {
  requiredErrorMessage,
  numberErrorMessage,
  MAX_FOUR_DECIMALS_REGEX,
} from 'constants/constants';

export const maxFourDecimalsTest = Yup.string()
  .typeError(numberErrorMessage)
  .test(
    'max-decimals',
    'Enter a number with a maximum of 4 decimal places',
    value => {
      if (!value) return true;
      return MAX_FOUR_DECIMALS_REGEX.test(value.toString());
    }
  )
  .nullable();

export const fuelValueSchema = Yup.object().shape({
  fuelValue: maxFourDecimalsTest,
});

export const sectionSchema = Yup.array().of(fuelValueSchema);

export const scopeOneValidationSchema = Yup.object().shape({
  fugitiveEmissions: Yup.array().of(
    Yup.object().shape({
      fuelValue: maxFourDecimalsTest.test(
        'refrigerantLabel',
        requiredErrorMessage,
        function (value) {
          const { refrigerantLabel } = this.parent;
          const isAnyFieldFilled = !!refrigerantLabel;
          if (isAnyFieldFilled && value == null) {
            return this.createError({ message: requiredErrorMessage });
          }
          return true;
        }
      ),
      refrigerantLabel: Yup.string()
        .nullable()
        .test('fuelValue', requiredErrorMessage, function (value) {
          const { fuelValue } = this.parent;
          const isAnyFieldFilled = !!fuelValue;
          if (isAnyFieldFilled && value == null) {
            return this.createError({ message: requiredErrorMessage });
          }
          return true;
        }),
    })
  ),
  stationaryCombustion: sectionSchema,
  processSources: sectionSchema,
  mobileSources: sectionSchema,
});
